import axios from 'axios';
import constants from 'config/constants';
import { getGlobalCurrentBatchUtils } from 'utils/commonFunc';

const APIS = {
  // POST (create) / PUT (update, studentCustomBillId goes in the body, not the URL)
  studentCustomBill: `/api/student-custom-bill`,
  // GET /{studentCustomBillId}, GET /batch?schoolId=&batchId=, GET /student?schoolId=&studentId=
};

const BASE = constants.API_BASE_URL;

export const GET_STUDENT_BILLINGS = 'GET_STUDENT_BILLINGS';
export const getStudentBillings = (billings, studentId) => ({
  type: GET_STUDENT_BILLINGS,
  billings,
  studentId,
});

export const GET_ALL_STUDENT_BILLINGS = 'GET_ALL_STUDENT_BILLINGS';
export const getAllStudentBillings = billings => ({
  type: GET_ALL_STUDENT_BILLINGS,
  billings,
});

export const addStudentBillingService = data => async () => {
  const { batchId = data?.batchId } = getGlobalCurrentBatchUtils();
  const { token, ...postData } = data;
  return axios.post(`${BASE}${APIS.studentCustomBill}`, { ...postData, batchId }, constants.setHeader(token));
};

export const updateStudentBillingService = data => async () => {
  const { token, ...postData } = data;
  return axios.put(`${BASE}${APIS.studentCustomBill}`, postData, constants.setHeader(token));
};

export const fetchStudentBillingsService = data => async dispatch => {
  const { schoolId, studentId, token } = data;
  try {
    const res = await axios.get(
      `${BASE}${APIS.studentCustomBill}/student${constants.makeParams({ schoolId, studentId })}`,
      constants.setHeader(token)
    );
    dispatch(getStudentBillings(res.data, studentId));
    return res.data;
  } catch (err) {
    console.error('err-fetchStudentBillingsService', err);
  }
};

export const fetchAllStudentBillingsService = data => async dispatch => {
  const { batchId = data?.batchId } = getGlobalCurrentBatchUtils();
  const { schoolId, token } = data;
  try {
    const res = await axios.get(
      `${BASE}${APIS.studentCustomBill}/batch${constants.makeParams({ schoolId, batchId })}`,
      constants.setHeader(token)
    );
    dispatch(getAllStudentBillings(res.data));
  } catch (err) {
    console.error('err-fetchAllStudentBillingsService', err);
  }
};
